import { addAlphaToHexString } from '@/utils/convert/addAlphaToHexString';
import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { Feature } from 'ol';
import type { MarkerPin, MarkerSurface } from 'minerva-plugin-api';
import { getPinFeature } from './getPinFeature';
import { getPinStyle } from './getPinStyle';

export const getMarkerSingleFeature = (
  marker: MarkerPin | MarkerSurface,
  {
    pointToProjection,
  }: {
    pointToProjection: UsePointToProjectionResult;
  },
): Feature => {
  const feature = getPinFeature(marker, pointToProjection, 'modelElement', true);
  const style = getPinStyle({
    color: addAlphaToHexString(marker.color, marker.opacity),
    value: marker.type === 'pin' ? marker.number : undefined,
  });

  feature.setStyle(style);
  return feature;
};
